module.exports = __webpack_public_path__ + "img/partner_8.4c6ee65b.png";